import { Pipe, PipeTransform } from '@angular/core'
import { lerp } from '@mos/shared/utils'

@Pipe({
	name: 'lerp',
	pure: true,
})
export class LerpPipe implements PipeTransform {
	transform(value: number, low: number, high: number): number {
		return lerp(value, low, high)
	}
}
